import { useEffect, useState } from 'react';

/*
 * Detectează dacă rulăm ca PWA instalat (mod standalone), pe Android/desktop
 * (`display-mode: standalone`) și pe iOS (`navigator.standalone`).
 * Întoarce false la SSR și pe prima randare, apoi se corectează pe client.
 */
export default function useStandalone() {
  const [standalone, setStandalone] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const mql = window.matchMedia('(display-mode: standalone)');
    const compute = () =>
      setStandalone(mql.matches || window.navigator.standalone === true);

    compute();
    if (mql.addEventListener) {
      mql.addEventListener('change', compute);
      return () => mql.removeEventListener('change', compute);
    }
    // Safari vechi
    mql.addListener(compute);
    return () => mql.removeListener(compute);
  }, []);

  return standalone;
}
